import React from 'react';
import Sidebar from './Sidebar';
import { useSidebar } from '../contexts/SidebarContext';

const Wrapper = ({ children, noScroll }) => {
  const { isOpen, close } = useSidebar();

  return (
    <div className='w-100 p-0 d-flex flex-column flex-grow-1 overflow-hidden' style={{ minHeight: 0 }}>
      <div className='d-flex flex-grow-1 overflow-hidden' style={{ minHeight: 0 }}>
        {/* Overlay for mobile - only visible when sidebar is open on mobile */}
        <div
          className={`sidebar-overlay ${isOpen ? 'show' : ''}`}
          onClick={close}
        />
        <Sidebar />
        <div className='w-100 overflow-auto px-md-4 px-3 py-2' style={{ minHeight: 0 }}>{children}</div>
      </div>
    </div>
  );
};

export default Wrapper;
